import { action, computed, observable } from 'mobx';

import { debounce } from '../App';
import { NavigationService } from '../NavigationService';
import { ITabStateProvider } from './ITabStateProvider';
import { SearchTabState } from './SearchTabState';
import { NavigationModel } from './NavigationModel';

export default class SearchPageState {
    private navigation: NavigationService;
    private providers: ITabStateProvider[];
    private navigationModel: NavigationModel;

    @observable.shallow
    public tabs: SearchTabState[] = [];

    @observable
    public tabIndex: number = 0;

    @observable
    public keyword = '';

    @observable
    public isLoading = true;


    @computed
    get allResultsCount() {
        return this.tabs.map(x => x.count).reduce((x, y) => x + y, 0)
    }

    debouncedSetKeyword: (keyword: string) => void;

    constructor(providers: ITabStateProvider[], navigation: NavigationService) {
        this.providers = providers;
        this.navigation = navigation;
        this.navigationModel = new NavigationModel(navigation);
        this.keyword = this.navigation.getQuery('phrase') || '';
        const tab = this.navigation.getQuery('tab') || '';
        const page = this.getPage();
        this.isLoading = true;
        this.debouncedSetKeyword = debounce(async (keyword) => {
            this.isLoading = true;
            if (this.keyword !== keyword) {
                this.keyword = keyword;
                this.navigationModel.phrase = keyword;
                await this.initialize(keyword);
            }
            this.isLoading = false;
        }, 500);
        this.initialize('').then(async (r) => {
            const index = this.tabs.findIndex(x => x.displayName.localeCompare(tab, undefined, { sensitivity: 'base' }) === 0);
            this.setTab(index);
            await this.initialize(this.keyword);
            await this.setPage(page);
            this.isLoading = false;
        });
    }

    setTab(index: number) {
        if (this.tabs.length > index && index >= 0) {
            this.tabIndex = index;
        }
        else {
            this.tabIndex = 0;
        }
        if (this.tabs.length > 0) {
            const value = this.tabs[this.tabIndex].displayName.toLocaleLowerCase();
            this.navigationModel.setTab(value, this.tabs[0].displayName);
        }
    }


    getPage() {
        const result = this.navigationModel.page;
        return result;
    }

    async setPage(page: number) {
        this.navigationModel.page = page;
        await this.tabs[this.tabIndex].setPage(page);
    }

    @action
    setKeyword(keyword: string) {
        this.debouncedSetKeyword(keyword);
    }

    @action
    async initialize(query: string | null) {
        const promises = await Promise.all(this.providers.map((provider) => {
            try {
                const tabs = provider.GetTabs(query || '');
                return tabs;
            }
            catch (e) {

            }
            return [];
        }));
        const tabs = promises.reduce((acc, val) => acc.concat(val), []);
        if (this.tabs.length === 0 || this.keyword === query) {
            this.tabs = tabs;
            const lastTab = tabs[this.tabIndex];
            if(!lastTab || lastTab.entries.length === 0)
            {
                const firstElementWithResults = tabs.find(x => x.count > 0);
                if (firstElementWithResults) {
                    this.tabIndex = tabs.indexOf(firstElementWithResults);
                }
            }
        }
    }
}
